import { Switch, Route, Redirect } from "react-router-dom";
import { AppRoutes } from "@ugg/shared/routes/app-routes";
import loadable from "@loadable/component";
import { MediaQuery } from "@outplayed/responsive";
import { useAdFree } from "lib/hooks/use-ad-free";
import { FreestarInContentContainer } from "components/Ads/FreestarInContent";
import { FreestarPlacements } from "components/Ads/freestar-placements";

const Overview = loadable(() => import("components/Champions/Overview"), {
  resolveComponent: (components) => components.Overview,
});
const CountersContainer = loadable(() => import("@ugg/shared/components/Champions/pages/Counters/CountersContainer"), {
  resolveComponent: (components) => components.CountersContainer,
});
const Matchups = loadable(() => import("@ugg/shared/components/Champions/pages/Matchups/Matchups"), {
  resolveComponent: (components) => components.Matchups,
});
const ItemsTableContainer = loadable(() => import("@ugg/shared/components/Champions/pages/ItemsTable/ItemsTableContainer"), {
  resolveComponent: (components) => components.ItemsTableContainer,
});
const ItemPathsContainer = loadable(() => import("@ugg/shared/components/Champions/pages/ItemPaths/ItemPathsContainer"), {
  resolveComponent: (components) => components.ItemPathsContainer,
});
const RunesTableContainer = loadable(() => import("@ugg/shared/components/Champions/pages/RunesTable/RunesTableContainer"), {
  resolveComponent: (components) => components.RunesTableContainer,
});
const RuneSetsContainer = loadable(() => import("@ugg/shared/components/Champions/pages/RuneSets/RuneSetsContainer"), {
  resolveComponent: (components) => components.RuneSetsContainer,
});
const SpellsAbilitiesContainer = loadable(
  () => import("@ugg/shared/components/Champions/pages/SpellsAbilities/SpellsAbilitiesContainer"),
  {
    resolveComponent: (components) => components.SpellsAbilitiesContainer,
  },
);
const ChampionDuos = loadable(() => import("@ugg/shared/components/Champions/pages/Duos/ChampionDuos"), {
  resolveComponent: (components) => components.ChampionDuos,
});

function CountersInContentAd() {
  const isAdFree = useAdFree();
  if (isAdFree) return null;
  return (
    <MediaQuery min="MOBILE_SMALL" max="MOBILE_LARGE">
      <FreestarInContentContainer
        id="ugg-counters-in-content"
        unitId="fs-counters-in-content"
        placement={FreestarPlacements.MedRectATF}
        slotClassName="flex items-center justify-center w-full h-[250px] overflow-hidden"
      />
    </MediaQuery>
  );
}

export function ChampionProfileRoutes() {
  return (
    <Switch>
      <Route
        path={AppRoutes.CHAMPION_PROFILE_COUNTERS}
        render={() => <CountersContainer inContentAdSlot={<CountersInContentAd />} />}
      />
      <Route path={AppRoutes.CHAMPION_PROFILE_MATCHUPS} component={Matchups} />
      <Route path={AppRoutes.CHAMPION_PROFILE_ITEMS} component={ItemsTableContainer} />
      <Route path={AppRoutes.CHAMPION_PROFILE_ITEM_PATHS} component={ItemPathsContainer} />
      <Route path={AppRoutes.CHAMPION_PROFILE_RUNES_TABLE} component={RunesTableContainer} />
      <Route path={AppRoutes.CHAMPION_PROFILE_RUNE_SETS} component={RuneSetsContainer} />
      <Route path={AppRoutes.CHAMPION_PROFILE_SPELLS_ABILITIES} component={SpellsAbilitiesContainer} />
      <Route path={AppRoutes.CHAMPION_PROFILE_DUOS} component={ChampionDuos} />
      {/*  
        Keep overview routes last because special game mode routes can conflict with above routes
        (e.g. CHAMPION_PROFILE_ITEM_PATHS, CHAMPION_PROFILE_RUNES_TABLE)
      */}
      <Route path={[AppRoutes.CHAMPION_PROFILE_BUILD, AppRoutes.CHAMPION_PROFILE_BUILD_SPECIAL_GAME_MODE]} component={Overview} />
      <Redirect from={AppRoutes.CHAMPION_PROFILE_ROOT} to={AppRoutes.CHAMPION_PROFILE_BUILD} />
    </Switch>
  );
}
